import { appDataReducerPaginationAndSearch } from './reducerMetadata';

// Overview of all applications of a website
export function appDataReducerWebsites(state, action) {
    // Set metadata for the overview
    const meta = appDataReducerPaginationAndSearch(action.websites.message.meta);

    // Set the items for in the overview
    const websites = action.websites.message.data.map((website) => ({
        id: website.id,
        name: website.name,
    }));

    return {
        meta,
        items: websites,
    };
}
